var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview-image-for-api"},[_c('el-image',{ref:"elImageRef",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.src,"preview-src-list":_vm.srcList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }